/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Advanced_Maintenance_Search_PlaceholderInputs */



/**
* | output |
* | --- |
* | "Serial number, gateway, version..." |
*
* @param {Advanced_Maintenance_Search_PlaceholderInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const advanced_maintenance_search_placeholder = /** @type {((inputs?: Advanced_Maintenance_Search_PlaceholderInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Advanced_Maintenance_Search_PlaceholderInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Serial number, gateway, version...")
	return /** @type {LocalizedString} */ ("Numéro de série, box, version...")
});